import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
const CheckboxesField = ({ formik = {}, hasError = false, fieldId, data }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const choices = typeof data.choices === 'string' ? JSON.parse(data.choices) : data.choices;
  const type = data.type.toLowerCase();
  // Conditional logic
  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      let show = true;
      data.conditionalLogic.rules.forEach((rule) => {
        if (rule.operator === 'IS') {
          if (values[`input_${rule.fieldId}`] !== rule.value) {
            show = false;
          }
        }
        if (rule.operator === 'IS_NOT') {
          if (values[`input_${rule.fieldId}`] === rule.value) {
            show = false;
          }
        }
      });
      if (!show) {
        return null;
      }
    }
  }
  return _jsxs("div", { className: `form-duuf-group form-duuf-group-${type} form-duuf-checkboxes-${fieldId}${data.cssClass ? ` ${data.cssClass}` : ''}`, children: [_jsx(Label, { fieldId: fieldId, data: data }), _jsx(Error, { fieldId: fieldId, data: data, hasError: hasError, formik: formik }), _jsx("div", { className: `form-duuf-choices-${fieldId}`, children: choices.map((choice, index) => {
        const fieldNumber = index + 1;
        const isChecked = values[`${fieldId}_${fieldNumber}`] ? values[`${fieldId}_${fieldNumber}`] === choice.value : false;
        return _jsxs("div", { className: "d-flex align-items-center flex items-center", children: [_jsx("input", { type: "checkbox", className: `form-duuf-checkbox form-duuf-checkbox-${type}`, id: choice.value, name: fieldId, placeholder: data.placeholder, onBlur: handleBlur, onChange: (event) => {
              const _value = values[fieldId];
              if (typeof _value !== 'string')
              return;
              const _values = _value.split(',');
              const _valueIndex = _values.indexOf(event.target.value);
              if (_valueIndex === -1) {
                _values.push(event.target.value);
              } else
              {
                _values.splice(_valueIndex, 1);
              }
              handleChange({
                target: {
                  name: event.target.name,
                  value: _values.join(',')
                }
              });
              handleChange({
                target: {
                  name: `${event.target.name}_${fieldNumber}`,
                  value: !isChecked ? event.target.value : ''
                }
              });
            }, value: choice.value, checked: isChecked }), _jsx("label", { htmlFor: choice.value, className: `form-duuf-checkbox-label form-duuf-checkbox-${type}`, children: choice.text })] }, choice.value);
      }) })] });
};
export default CheckboxesField;